<template lang="html">
  <label class="error">
    <span v-html="visibleMessage" />
  </label>
</template>
<script>
import safeGet from '../../store/pathifyUtilities';
import errorMessages from '../../errorMessages';

export default {
  props: {
    fieldName: {
      type:    String,
      default: '',
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    validatorKey: {
      type:    String,
      default: null,
    },
  },
  data() {
    return {
      cachedMessages: null,
    };
  },
  computed: {
    backendErrors: safeGet('backendErrors', []),
    messages() {
      if (!this.validatorField.$pending || this.cachedMessages === null) {
        /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
        this.cachedMessages = [];
        let fieldHasErrors = false;
        if (this.backendErrors) {
          fieldHasErrors = Object.prototype.hasOwnProperty.call(this.backendErrors, this.fieldName);
        }

        if (this.validatorField.$error) {
          let errors = Object.keys(this.validatorField.$params);
          errors = errors.filter((error) => !this.validatorField[error]);

          /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
          this.cachedMessages = errorMessages(errors, this.validatorKey);
        } else if (fieldHasErrors) {
          this.validatorField.$reset();

          /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
          this.cachedMessages = this.backendErrors[this.fieldName];
        }
      }
      return this.cachedMessages;
    },
    visibleMessage() {
      if (this.messages.length === 0) return '';

      return this.messages[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  display: block;
  margin-bottom: 10px;
  color: #d0021b !important;
}
</style>
